import { ref, watch } from 'vue';
import {ElMessageBox} from 'element-plus'

export const setNotShowIn24HourHook = (countDownSecond: number) => {
    const dialogVisible = ref(false);
    const isChecked = ref(false);
    const countDownSecondOrigin = ref(countDownSecond);
    const setNotShowIn24Hour = (value: boolean) => {
        console.log('value', value);
        if (value) {
            let currentStamp: number = +new Date();
            localStorage.setItem('notShowIn24Hour', currentStamp.toString());
        } else {
            localStorage.removeItem('notShowIn24Hour');
        }
    };
    watch(dialogVisible, (value) => {
        if (value) {
            countDown()
        }
    })
    const countDown = () => {
        countDownSecondOrigin.value = countDownSecond
        const timer = setInterval(() => {
            countDownSecondOrigin.value--
            if (countDownSecondOrigin.value <= 0) {
                clearInterval(timer)
                dialogVisible.value = false
            }
        }, 1000)
    }
    const judgeIsNotShowIn24Hour = () => {
        let currentStamp = +new Date();
        let notShowIn24Hour = localStorage.getItem('notShowIn24Hour');
        if (notShowIn24Hour) {
            let diff = currentStamp - +notShowIn24Hour;
            if (diff <= 24 * 60 * 60 * 1000) {
                return true;
            } else {
                isChecked.value = false
                return false;
            }
        } else {
            isChecked.value = false
            return false;
        }
    }
    
    return {
        dialogVisible,
        isChecked,
        judgeIsNotShowIn24Hour,
        countDownSecondOrigin,
        setNotShowIn24Hour,
    };
};

export const exportTips = (tipType:number) => {
    let htmlTemp = ''
    if (tipType === 1) {
        htmlTemp = `<span>根据<a class="href-link-sensitive" target="_blank" href="https://oa.feishu.cttq.com/announcement/detail/7309405833762291881?from=from_parent_sheet">《正大天晴药业集团数据权限管理规范》</a>中数据安全使用的要求，您对所有数据的导出行为都会被记录，禁止进行任何非必要的数据导出、截图、拍照、传播。如引起数据泄露，一切后果自行承担!</span>`
    } else {
        htmlTemp = `<span>根据数据安全使用的要求，您对所有数据的导出行为都会被记录，禁止进行任何非必要的数据导出、截图、拍照、传播。如引起数据泄露，一切后果自行承担!  </span>`
    }
    return new Promise((resolve) => {
        ElMessageBox.confirm(htmlTemp, '敏感数据导出提示', {
            confirmButtonText: '确认继续',
            cancelButtonText: '取消导出',
            dangerouslyUseHTMLString: true,
            type: 'warning',
        }).then(() => {
            resolve(true)
        }).catch(() => {
            resolve(false)
        })
    })
}